export const getPreviewStyles = () => ({
  adPreviewContainer: {
  },
});
